function toThousand(value: string | number): string {
  return `IDR ${String(value).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`;
}

export default {
  toThousand,
};
